/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/webhook" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsWebhook } from "./constants";
import type { AppsAppGroupIdChartsWebhookResult } from "./types";

export const getAppsAppGroupIdChartsWebhook = reactQueryFetcherAdapter(
  appsAppGroupIdChartsWebhook,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsWebhookResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/webhook`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
